import { connect } from 'react-redux';
import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import EnergySavingsLeafRoundedIcon from '@mui/icons-material/EnergySavingsLeafRounded';
import { createActions } from '../../store';
import { trackEvent, AnalyticsConstants } from '../../../../../utilities/analyticsUtilities';

const OptimizationModeToggleButton = (props) => {
    const { optimizationModeEnabled, savingInProgress, setOptimizationMode } = props;

    const handleClick = () => {
        const enabled = !optimizationModeEnabled;

        setOptimizationMode(enabled);

        // Only turning the mode on is tracked.
        if (enabled) {
            trackEvent('Toggled Optimization Mode', {
                enabled: enabled,
                category: AnalyticsConstants.VIDEO_CATEGORY
            });
        }
    };

    const tooltipTitle = savingInProgress
        ? 'Optimization Mode cannot be changed while the project is being saved.'
        : optimizationModeEnabled
            ? 'Optimization Mode is on. Click to turn off.'
            : 'Optimization Mode reduces memory and CPU usage by limiting some editor features. Exports are not affected.';

    return (
        <Tooltip
            title={tooltipTitle}
            placement='top'
            arrow
        >
            {/* The span keeps the tooltip working while the button is disabled. */}
            <span>
                <IconButton
                    onClick={handleClick}
                    color={optimizationModeEnabled ? 'primary' : 'default'}
                    aria-label='Optimization Mode'
                    aria-pressed={optimizationModeEnabled}
                    disabled={savingInProgress}
                    size="large">
                    <EnergySavingsLeafRoundedIcon />
                </IconButton>
            </span>
        </Tooltip>
    );
};

const mapStateToProps = (state) => {
    const { optimizationModeEnabled } = state.create;
    // Toggling mid-save is blocked: the mode changes how resources are uploaded and
    // which preview work runs, and flipping it under the saving pipeline's feet would
    // change behavior between saving steps.
    const { savingInProgress } = state.create.videoSavingState;
    return { optimizationModeEnabled, savingInProgress };
};

const mapDispatchToProps = (dispatch) => {
    const setOptimizationMode = (enabled) => dispatch(createActions.setOptimizationMode(enabled));
    return { setOptimizationMode };
};

export default connect(mapStateToProps, mapDispatchToProps)(OptimizationModeToggleButton);
